module.exports = __webpack_public_path__ + "img/arrow-orange.c24c1c77.svg";